document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const shadowHost = document.querySelector('#app-embed-container-482623');
    
    if (shadowHost && shadowHost.shadowRoot) {
      const shadowRoot = shadowHost.shadowRoot;

      // Avoid injecting styles multiple times
      if (shadowRoot.querySelector('#custom-popup-style')) {
        clearInterval(interval);
        return;
      }

      const style = document.createElement('style');
      style.id = 'custom-popup-style';
      style.textContent = `
        /* Popup container
        section[role="dialog"] {
          background-color: #fffaf5 !important;
          border-radius: 16px !important;
          padding: 24px !important;
        }
        */

        section[role="dialog"] {
          border-radius: 3px !important;
        }

        h2 {
          font-size: 13px !important;
          font-weight: 200 !important;
          // font-family: sans-serif !important;
        }
        
        /* Form fields */
        input {
          padding: 14px 16px !important;
          font-size: 12px !important;
          border-radius: 0px !important;
          border: 0px !important;
          height: 8px !important;
          letter-spacing: 0.3px !important;
        }

        input::placeholder {
          color: #888 !important;
          font-size: 12px !important;
          opacity: 1 !important;
          letter-spacing: 0.3px !important;
        }

        /* Labels */
        label {
          font-size: 14px !important;
          margin-bottom: 6px !important;
          display: none !important;
        }

        /* Submit button */
        button {
          // background-color: #000 !important;
          color: #fff !important;
          padding: 12px 24px !important;
          border-radius: 0px !important;
          text-transform: uppercase !important;
          font-weight: 400 !important;
          font-family: sans-serif !important;
          font-size: 11px !important;
        }

        p {
          font-size: 11px !important;
          font-weight: 400 !important;
          line-height: 14px !important;
          color: #121212 !important;
        }

        [data-testid="image"] {
          border-radius: 0px !important;
        }
      `;

      shadowRoot.appendChild(style);

      setTimeout(() => {
        const firstNameInput = shadowRoot.querySelector('#first_name');
        const emailInput = shadowRoot.querySelector('#email');

        if (firstNameInput) {
          firstNameInput.placeholder = 'Tu Nombre';
        }
        if (emailInput) {
          emailInput.placeholder = 'Correo Electronico';
        }
      }, 100);
      
      clearInterval(interval);
    }
  }, 300);
});